import React, { Fragment } from "react";
import { formatMetricUnit, UnitRate } from "../../../api/services";
import { Charge } from "./Charge";
import { Divider } from "@material-ui/core";

const formatUnitRate = (value: string, unit: string) => {
  let rate = `${value} ${formatMetricUnit(unit)} `;
  if (unit.startsWith("£")) {
    rate = rate.replace(" £", "");
    rate = "£" + rate;
  }
  return rate;
};

// Display a Charge line for each rate in a UnitRate
export const UnitRateCharge: React.FC<UnitRate> = ({
  rates,
  metricUnit,
  id,
  name,
}) => {
  return (
    <Fragment key={id}>
      {rates.map((rate) => (
        <Fragment key={id + rate.name + rate.value}>
          <Charge
            name={`${name !== "Default" ? name : "Rate"}${
              rate.name ? `: ${rate.name}` : ""
            }`}
            price={
              rate.value === null ? "-" : formatUnitRate(rate.value, metricUnit)
            }
            data-testid="UnitRateCharge"
          />
          <Divider />
        </Fragment>
      ))}
    </Fragment>
  );
};
